import { Editor } from '@tiptap/core'
import StarterKit from '@tiptap/starter-kit'
import Link from '@tiptap/extension-link'
import Image from '@tiptap/extension-image'
import Iframe from "./extensions/iframe.js";

export default (content) => {
    let editor;

    return {
        content: content,
        updatedAt: Date.now(),

        mount(element) {
            const _this = this;

            editor = new Editor({
                element: element,
                extensions: [
                    StarterKit.configure({
                        link: false,
                    }),
                    Link.extend({ inclusive: false }).configure({
                        openOnClick: false
                    }),
                    Image,
                    Iframe
                ],
                content: this.content,

                onCreate({ editor }) {
                    _this.updatedAt = Date.now()
                },
                onUpdate: ({ editor }) => {
                    this.content = editor.getHTML()
                    _this.updatedAt = Date.now()
                },
                onSelectionUpdate({ editor }) {
                    _this.updatedAt = Date.now()
                },

                editorProps: {
                    attributes: {
                        class: 'w-full py-2 px-4 mx-auto focus:outline-none',
                    },
                },
            })

            this.$watch('content', (content) => {
                if (content === editor.getHTML()) return

                editor.commands.setContent(content, { emitUpdate: false })
            })

            window.addEventListener('rich-text.upload-file', (event) => {
                _this.setImage(event.detail.url);
            })
        },
        isLoaded() {
            return editor
        },
        isActive(type, opts = {}) {
            return type ? editor.isActive(type, opts) : false
        },
        isDisabled(type) {
            if (type === 'bold') {
                return !editor.can().chain().focus().toggleBold().run()
            }

            if (type === 'italic') {
                return !editor.can().chain().focus().toggleItalic().run()
            }

            if (type === 'underline') {
                return !editor.can().chain().focus().toggleUnderline().run()
            }

            if (type === 'unlink') {
                return !editor.isActive('link');
            }

            return false;
        },
        toggleHeading(opts) {
            editor.chain().toggleHeading(opts).focus().run()
        },
        toggleBold() {
            editor.chain().focus().toggleBold().run()

            this.updatedAt = Date.now()
        },
        toggleItalic() {
            editor.chain().toggleItalic().focus().run()

            this.updatedAt = Date.now()
        },
        toggleUnderline() {
            editor.chain().focus().toggleUnderline().run()

            this.updatedAt = Date.now()
        },
        toggleBulletList() {
            editor.chain().focus().toggleBulletList().run()
        },
        toggleOrderedList() {
            editor.chain().focus().toggleOrderedList().run()
        },
        toggleCodeBlock() {
            editor.chain().focus().toggleCodeBlock().run()
        },
        toggleBlockQuote() {
            editor.chain().focus().toggleBlockquote().run()
        },
        toggleUndo() {
            editor.chain().focus().undo().run()
        },
        toggleRedo() {
            editor.chain().focus().redo().run()
        },
        toggleLink() {
            editor.commands.extendMarkRange('link');

            const {from, to}  = editor.view.state.selection;

            this.$refs.linkAction.value = editor.getAttributes('link').href || null;
            this.$refs.linkText.value = editor.view.state.doc.textBetween(from, to) || null;
        },
        unsetLink() {
            editor.chain().focus().unsetLink().run();
        },
        setLink() {
            const {from}  = editor.view.state.selection;

            const link = this.$refs.linkAction.value || null;
            const text = this.$refs.linkText.value || link;

            if (!link) {
                return;
            }

            editor.commands.focus();

            editor.view.dispatch(
                editor.view.state.tr.insertText(text)
            );

            editor
                .chain()
                .setTextSelection({from, to: from + text.length})
                .setLink({ href: link, target: '_blank' })
                .run();

            this.$dispatch('close-dropdown');
        },
        toggleImage() {
            this.$dispatch('rich-text::modal::upload-file');
        },
        setImage(url) {
            editor.chain().focus().setImage({ src: url }).run()
        },
        setIframe() {
            const link = this.$refs.linkEmbed.value || null;

            editor.chain().focus().setIframe({ src: link }).run()

            this.$dispatch('close-dropdown');

            this.$refs.linkEmbed.value = null;
        }
    }
}
